define((require) => {
    "use strict";

    const ButtonWidgetModel               = require("shared/ui/experience/widgets/button/ButtonWidgetModel");
    const AbstractWidgetPropertiesView    = require("ui/experience/widgets/AbstractWidgetPropertiesView");
    const AnimationPropertiesView         = require("ui/experience/widgets/animations/AnimationPropertiesView.js");
    const ActionPropertiesView            = require("ui/experience/action/ActionPropertiesView.js");
    const ColorPicker                     = require("shared/services/ColorPicker");
    const SizeAndPositionPropertiesView   = require("ui/experience/widgets/SizeAndPositionPropertiesView.js");
    const StylePropertiesView             = require("ui/experience/widgets/StylePropertiesView.js");
    const ButtonType                      = require("shared/ui/experience/widgets/button/ButtonType");
    const IconPropertiesView              = require("ui/experience/widgets/button/IconPropertiesView");
    const Storage                         = require("shared/services/Storage");
    const LabelPropertiesView             = require("ui/experience/widgets/button/LabelPropertiesView");
    const _                               = require("underscore");
    const template                        = require("ui/experience/widgets/button/ButtonWidgetPropertiesView.tpl");

    const EXPAND_PROPERTY = "buttonPropertiesExpanded";
    /**
     *
     * @class ButtonWidgetPropertiesView
     * @constructor
     *
     * @cfg {ButtonWidgetModel} model The model for the button widget being edited.
     */
    return AbstractWidgetPropertiesView.extend("ButtonWidgetPropertiesView", {

        className: "button-widget-properties-view",

        expandProperty: EXPAND_PROPERTY,

        template,

        templateHelpers() {
            return {
                ButtonType
            };
        },

        _backgroundColorPicker: null,

        ui: {
            legend: "[data-target=\".button-properties-container\"]",
            buttonProperties: ".button-properties-container",
            buttonBackgroundColorInput: ".button-background-color-input",
            buttonBackgroundColorBox: ".button-background-color-box",
            buttonTypeSelect: ".button-type"
        },

        regions: {
            labelProperties: ".label-properties-region",
            iconProperties: ".icon-properties-region",
            sizeAndPositionProperties: ".size-and-position-properties",
            styleProperties: ".style-properties",
            analyticsProperties: ".analytics-properties",
            animationProperties: ".animation-properties",
            actionProperties: ".action-properties"
        },

        bindings: {
            ".button-type": "buttonType",
            ".button-background-color-input": {
                observe: "backgroundColor",
                onSet(color) {
                    return this._backgroundColorPicker.hexOrDefault(color);
                }
            },
            ".padding": {
                observe: "padding",
                onSet(value) {
                    return parseInt(value, 10);
                }
            }
        },

        modelEvents: {
            "change": "_changeHandler",
            "change:buttonType": "_buttonTypeSelectHandler"
        },

        onClose() {
            this._backgroundColorPicker.dispose();
        },

        onRender() {
            this.__super();

            this.iconProperties.show(new IconPropertiesView({model: this.model}));
            this.labelProperties.show(new LabelPropertiesView({model: this.model}));
            this.sizeAndPositionProperties.show(new SizeAndPositionPropertiesView({
                model: this.model,
                hideSizeControls: true,
                widgetView: this.options.widgetView
            }));
            this.actionProperties.show(new ActionPropertiesView({model: this.model, showEffects: true}));
            this.styleProperties.show(new StylePropertiesView({model: this.model, hideRadiusControls: false}));
            this.analyticsProperties.show(this._setAnalyticsLabel({model: this.model}));
            this.animationProperties.show(new AnimationPropertiesView({model: this.model, widgetView: this.options.widgetView}));
            this._backgroundColorPicker = new ColorPicker({
                color: this.model.get("backgroundColor"),
                input: this.ui.buttonBackgroundColorInput,
                colorBox: this.ui.buttonBackgroundColorBox,
                includeTransparency: true
            });

            this._renderButtonTypeSpecific();
        },

        _renderButtonTypeSpecific() {
            const buttonType = this.model.get("buttonType");

            switch (buttonType) {
                case ButtonType.TEXT_AND_ICON:
                    this.labelProperties.currentView.unhide();
                    this.iconProperties.currentView.unhideIconPositionSelect();
                    this.iconProperties.currentView.unhide();
                    break;
                case ButtonType.TEXT_ONLY:
                    this.labelProperties.currentView.unhide();
                    this.iconProperties.currentView.unhideIconPositionSelect();
                    this.iconProperties.currentView.hide();
                    break;
                case ButtonType.ICON_ONLY:
                    this.labelProperties.currentView.hide();
                    this.iconProperties.currentView.hideIconPositionSelect();
                    this.iconProperties.currentView.unhide();
                    break;
                default:
                    throw new Error(`unexpected buttonType: ${buttonType}`);
            }
        },

        _buttonTypeSelectHandler() {
            this.model.set("buttonType", this.ui.buttonTypeSelect.val());
            this._renderButtonTypeSpecific();
        },

        _changeHandler() {
            const props = this.model.pick(_.keys(ButtonWidgetModel.buttonDefaults));
            Storage.Local.update(Storage.Keys.LAST_USED_BUTTON_PROPERTIES, props);
        }
    }, {
        EXPAND_PROPERTY
    });
});



// WEBPACK FOOTER //
// ./src/editor/ui/experience/widgets/button/ButtonWidgetPropertiesView.js